<template>
  <iframe
    class="debugger-iframe"
    :src="debuggerUrl"
    frameborder="0"
    allow="microphone; camera"
  ></iframe>
</template>

<script>
import { getToken } from '@/utils/auth'

export default {
  computed: {
    debuggerUrl() {
      return `${webConfig.api.debugger}/${this.$route.params.id}/debug?hideMenu=1&token=${getToken()}&t=${new Date().getTime()}`
    }
  }
}
</script>

<style lang="scss" scoped>
.debugger-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}
</style>
